<template>
    <AppLayout
        page="/dashboard"
        pageTitle="Dashboard"
        :tabs="true"
        ref="appLayout"
    >
        <template #tabs>
            <v-tabs
                v-model="selectedTab"
                background-color="transparent"
                height="42px"
                class="pr-5 custom-tabs"
            >
                <v-tab
                    v-for="tab in filterTabs"
                    :key="tab.title"
                    class="no-link"
                    :href="tab.href"
                >
                    <Link
                        class="no-link flex align-center justify-center min-h-full"
                        @click="selectedPeople = []"
                        :href="tab.href"
                        preserve-state
                        >{{ tab.title }}</Link
                    ></v-tab
                >
            </v-tabs>
        </template>

        <v-tabs-items :value="selectedTab" touchless>
            <v-tab-item value="/dashboard/studio" :transition="false">
                <div class="pa-1 animate__animated animate__fadeIn">
                    <SoliStats
                        v-if="can('View statistical reports')"
                        :key="activeMemberships"
                        :activeMemberships="activeMemberships"
                        :firstVisits="assessments"
                        :enrollments="enrollments"
                        :withdrawals="withdrawals"
                        :inquiries="inquiries"
                        :leadConversion="leadConversion"
                        :assessmentConversion="assessmentConversion"
                        dateHeaders
                    ></SoliStats>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card class="soli-round">
                                <v-container>
                                    <v-card-title class="soli-grey pb-2">
                                        Studio Availability <v-spacer />
                                        <v-btn
                                            v-if="showAiSummary"
                                            icon
                                            outlined
                                            color="accent"
                                            small
                                            :loading="aiSummaryLoading"
                                            class="text-shadow-blue"
                                            @click="
                                                $refs.availabilityFinder.aiSummary()
                                            "
                                            ><v-icon small
                                                >auto_awesome</v-icon
                                            ></v-btn
                                        >
                                    </v-card-title>
                                    <AvailabilityFinder
                                        ref="availabilityFinder"
                                        :ageRanges="ageRanges"
                                        :skillLevels="skillLevels"
                                        @loaded="showAiSummary = true"
                                        @aiSummaryLoading="
                                            aiSummaryLoading = $event
                                        "
                                        :errors="errors"
                                    /> </v-container
                            ></v-card>
                            <v-card class="soli-round mt-6">
                                <v-container>
                                    <v-card-title class="soli-grey">
                                        Upcoming Events
                                    </v-card-title>
                                    <v-list class="pa-0">
                                        <v-list-item
                                            v-for="(
                                                event, idx
                                            ) in eventRegisters"
                                            :key="event.id"
                                            class="soli-round"
                                            :class="{
                                                'mb-3':
                                                    idx <
                                                    eventRegisters.length - 1,
                                            }"
                                            @click="
                                                $inertia.get(
                                                    route(
                                                        'eventRegistration.show',
                                                        event.hashId
                                                    )
                                                )
                                            "
                                        >
                                            <v-list-item-avatar
                                                size="64"
                                                class="mr-8"
                                            >
                                                <img
                                                    :src="event.photo"
                                                    width="64"
                                                    height="64"
                                                />
                                            </v-list-item-avatar>
                                            <v-list-item-content
                                                class="text-align-start"
                                            >
                                                <v-list-item-title
                                                    class="soli-grey"
                                                    >{{ event.name }}
                                                </v-list-item-title>
                                                <v-list-item-subtitle>
                                                    {{ event.date }}
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle>
                                                    {{ event.time }}
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle>
                                                    Attending:
                                                    {{ event.attending }}/{{
                                                        event.capacity
                                                    }}
                                                </v-list-item-subtitle> </v-list-item-content
                                            ><v-list-item-action
                                                ><Clipboard
                                                    icon="share"
                                                    color="accent"
                                                    :text="event.link"
                                                ></Clipboard></v-list-item-action></v-list-item
                                    ></v-list> </v-container
                            ></v-card>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-card class="soli-round">
                                <v-container>
                                    <v-card-title
                                        class="soli-grey pb-0 overflow-visible"
                                    >
                                        First Visits
                                        <v-spacer />
                                        <v-menu left offset-y>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-btn
                                                    id="menu-button"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    small
                                                    icon
                                                    outlined
                                                    color="accent"
                                                    class="z-50"
                                                >
                                                    <v-icon
                                                        small
                                                        class="soli-blue-text text-shadow-blue"
                                                        >tune</v-icon
                                                    ></v-btn
                                                >
                                            </template>
                                            <v-list>
                                                <v-list-item>
                                                    <v-btn
                                                        :ripple="false"
                                                        @click="
                                                            hideCanceled =
                                                                !hideCanceled
                                                        "
                                                        outlined
                                                        class="flex soli-round soli-grey"
                                                    >
                                                        <small class="mr-2">
                                                            Hide Canceled
                                                        </small>
                                                        <v-icon
                                                            :color="
                                                                hideCanceled
                                                                    ? 'accent'
                                                                    : null
                                                            "
                                                            >{{
                                                                hideCanceled
                                                                    ? "toggle_on"
                                                                    : "toggle_off"
                                                            }}</v-icon
                                                        ></v-btn
                                                    >
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-btn
                                                        :ripple="false"
                                                        @click="
                                                            upcoming = !upcoming
                                                        "
                                                        outlined
                                                        class="flex soli-round soli-grey"
                                                    >
                                                        <small class="mr-2">
                                                            {{
                                                                "View Last Week"
                                                            }}
                                                        </small>
                                                        <v-icon
                                                            :color="
                                                                upcoming
                                                                    ? null
                                                                    : 'accent'
                                                            "
                                                            >{{
                                                                upcoming
                                                                    ? "toggle_off"
                                                                    : "toggle_on"
                                                            }}</v-icon
                                                        ></v-btn
                                                    >
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-card-title>

                                    <!--<SoliToggle
                                        v-if="!assessmentTab"
                                        option1="Upcoming"
                                        option2="Last Week"
                                        v-model="upcoming"
                                    ></SoliToggle>
                                    -->
                                    <v-tabs
                                        v-model="assessmentTab"
                                        class="px-4"
                                        dense
                                    >
                                        <v-tab>Review</v-tab>
                                        <v-tab
                                            ><v-badge
                                                v-if="getRecentFeedback"
                                                :content="getRecentFeedback"
                                                >Feedback</v-badge
                                            >
                                            <div v-else>Feedback</div></v-tab
                                        >
                                    </v-tabs>
                                    <v-tabs-items
                                        v-model="assessmentTab"
                                        touchless
                                    >
                                        <v-tab-item>
                                            <v-container>
                                                <DashboardFirstVisits
                                                    :events="
                                                        upcoming
                                                            ? upcomingAssessments?.filter(
                                                                  (e) =>
                                                                      hideCanceled
                                                                          ? !e
                                                                                .lesson
                                                                                .cancelled
                                                                          : true
                                                              )
                                                            : weekReview?.filter(
                                                                  (e) =>
                                                                      hideCanceled
                                                                          ? !e
                                                                                .lesson
                                                                                .cancelled
                                                                          : true
                                                              )
                                                    "
                                                    :errors="errors"
                                                    @success="showMessage()"
                                                />
                                                <!--<DashboardAttendance
                                                    :attendances="
                                                        upcomingAssessments
                                                    "
                                                />-->
                                            </v-container>
                                        </v-tab-item>
                                        <v-tab-item>
                                            <v-container>
                                                <AssessmentFeedback
                                                    :events="feedback"
                                            /></v-container>
                                        </v-tab-item>
                                    </v-tabs-items> </v-container
                            ></v-card>
                        </v-col>
                    </v-row>
                </div>
            </v-tab-item>
            <v-tab-item value="/dashboard/reports" :transition="false">
                <div class="pa-1 animate__animated animate__fadeIn">
                    <DashboardReports />
                </div>
            </v-tab-item>
            <v-tab-item value="/dashboard/apps" :transition="false">
                <div class="pa-1 animate__animated animate__fadeIn">
                    <v-container>
                        <v-row>
                            <v-col
                                cols="3"
                                class="flex justify-center"
                                v-for="app in apps"
                                :key="app.src"
                            >
                                <a :href="app.url" target="_blank">
                                    <div class="flex flex-col">
                                        <div class="flex justify-center">
                                            <v-avatar
                                                ><v-img :src="app.src"></v-img
                                            ></v-avatar>
                                        </div>
                                        <small
                                            class="py-3 flex justify-center"
                                            style="white-space: nowrap"
                                            >{{ app.name }}</small
                                        >
                                    </div></a
                                >
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
            </v-tab-item>
            <v-tab-item value="/dashboard/me" :transition="false">
                <div class="pa-1 animate__animated animate__fadeIn">
                    <DashboardTeacher
                        :myAgenda="myAgenda"
                        :teachingHours="teachingHours"
                        @success="showMessage()"
                    ></DashboardTeacher>
                </div>
            </v-tab-item>
            <v-tab-item value="/dashboard/settings" :transition="false">
                <div class="pa-1 animate__animated animate__fadeIn">
                    <DashboardSettings />
                </div>
            </v-tab-item>
        </v-tabs-items>
    </AppLayout>
</template>

<script>
import AppLayout from "./../Layouts/AppLayout";
import LessonAgenda from "./../Components/Dashboard/LessonAgenda";
import AssessmentFeedback from "./../Components/Dashboard/AssessmentFeedback";
import DashboardTeacher from "./../Components/Dashboard/DashboardTeacher";
import DashboardReports from "./../Components/Dashboard/DashboardReports";
import DashboardSettings from "./../Components/Dashboard/DashboardSettings";
import AvailabilityFinder from "./../Components/Dashboard/AvailabilityFinder";
import Clipboard from "./../Components/Clipboard.vue";

import { Link } from "@inertiajs/vue2";
import DashboardAttendance from "../Components/Dashboard/Attendance/DashboardAttendance.vue";
import DashboardFirstVisits from "../Components/Dashboard/DashboardFirstVisits.vue";

import CRMDrawer from "../Layouts/CRMDrawer.vue";

export default {
    layout: CRMDrawer,
    props: {
        upcomingAssessments: { type: Array, default: null },
        activeMemberships: { type: Number, default: null },
        assessments: { type: Number, default: null },
        enrollments: { type: Number, default: null },
        withdrawals: { type: Number, default: null },
        inquiries: { type: Number, default: null },
        leadConversion: { type: Number, default: null },
        assessmentConversion: { type: Number, default: null },
        eventRegisters: { type: Array, default: null },
        myAgenda: { type: Array, default: null },
        weekReview: { type: Array, default: null },
        teachingHours: { type: Array, default: () => [] },
        feedback: { type: Array, default: null },
        errors: {},
        ageRanges: {
            type: Array,
            default: () => [],
        },
        skillLevels: {
            type: Array,
            default: () => [],
        },
    },
    components: {
        AppLayout,
        LessonAgenda,
        AssessmentFeedback,
        DashboardTeacher,
        DashboardReports,
        DashboardSettings,
        DashboardAttendance,
        AvailabilityFinder,
        Link,
        Clipboard,
        DashboardFirstVisits,
    },
    data() {
        return {
            assessmentTab: 0,
            upcoming: true,
            hideCanceled: false,
            searchBy: true,
            showAiSummary: false,
            aiSummaryLoading: false,
            tabs: [
                { title: "Studio", href: "/dashboard/studio", manager: true },
                { title: "Me", href: "/dashboard/me", teacher: true },
                {
                    title: "Reports",
                    href: "/dashboard/reports",
                    teacher: true,
                    manager: true,
                },
                { title: "Apps", href: "/dashboard/apps", manager: true },
                /*{
                    title: "Settings",
                    href: "/dashboard/settings",
                    manager: true,
                },*/
            ],
            selectedTab: window.location.pathname,
            apps: [
                {
                    name: "Slack",
                    src: "/slack.png",
                    url: "https://musicologieworkspace.slack.com/",
                },
                {
                    name: "Gmail",
                    src: "/gmail.png",
                    url: "https://gmail.com",
                },
                {
                    name: "Brand Portal",
                    src: "/brand-portal.png",
                    url: "https://musicologie.s4mrc.com/",
                },
                {
                    name: "Emma",
                    src: "/emma.png",
                    url: "https://app.e2ma.net/app2/login/",
                },
                {
                    name: "HiringThing",
                    src: "/hiringThing-logo.jpeg",
                    url: "https://musicologie.hiringthing.com/admin",
                },
                {
                    name: "Canva",
                    src: "/canva.webp",
                    url: "https://www.canva.com/brand/brand-templates",
                },
                {
                    name: "Google Drive",
                    src: "/google_drive_logo.png",
                    url: "https://drive.google.com",
                },
                {
                    name: "Monday.com",
                    src: "/monday_logo.webp",
                    url: "https://musicologie.monday.com/",
                },
                {
                    name: "Online Training",
                    src: "/musicologie-m.png",
                    url: "https://support.musicologielessons.com/",
                },
            ],
        };
    },
    computed: {
        filterTabs() {
            return this.tabs.filter((e) => {
                // if only teacher, return only Me
                if (this.is("Teacher") && !this.can("View generic reports")) {
                    return e.teacher;
                }
                // if not teacher, but can view generic reports, return only studio
                if (!this.is("Teacher") && this.can("View generic reports")) {
                    return e.manager;
                }

                // if both, return both
                return e;
            });
        },
        getRecentFeedback() {
            return this.feedback?.filter((e) => e.recent).length;
        },
    },
    methods: {
        showMessage() {
            this.$refs.appLayout.showMessage = true;
        },
        testSubmit() {
            return new Promise((resolve) => {
                this.$inertia.post(
                    route("auth.location", 1),
                    {
                        redirect: "/dashboard",
                    },
                    {
                        preserveState: true,
                        preserveScroll: true,
                        onSuccess: () => {
                            this.$refs.appLayout.showMessage = true;
                            resolve();
                        },
                        onError: (errors) => {
                            this.errors = errors;
                            resolve();
                        },
                    }
                );
            });
        },
    },
};
</script>
